module.exports = __webpack_public_path__ + "img/video-7.0ac45ea9.png";